import { Page } from '@/core/architecture'

import { MembershipTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * Membership Page
 * Implemented as a practical sample.
 */
export const Membership: Page = () => {
  const { state, actions } = useViewModel()

  return <MembershipTemplate state={state} {...actions} />
}
